import { gql } from 'apollo-boost'

const query = gql`
  query {
    shop {
      paymentSettings {
        countryCode
        currencyCode
        enabledPresentmentCurrencies
      }
    }
  }
`

export const queryShopifyShop = (client) => client.query({ query })

export default queryShopifyShop
